import React from "react";
import { TextField } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { antwoordOp, zetAntwoord } from "../../../lib/enquete";
import { setAddFields } from "../../../store/slice/feedback.slice";
import { hoekMaat } from "../../../lib/hoek";

// Open tekst bij een enquêtevraag: de toelichting naast de sterren, of de vraag "Wat kunnen we beter doen?".
// Het antwoord hoort bij de vraag via idenquetefield (lib/enquete.js, 14-10-2026).
export const AntwoordTekst = ({ vraag, placeholder, Css, minRows = 4 }) => {
  const dispatch = useDispatch();
  const { addFields } = useSelector((s) => s.feedback);
  const opgeslagen = antwoordOp(addFields, vraag?.idenquetefield)?.data ?? "";
  const [tekst, setTekst] = React.useState(opgeslagen);

  React.useEffect(() => {
    const klok = setTimeout(() => {
      if (tekst !== opgeslagen) dispatch(setAddFields(zetAntwoord(addFields, vraag?.idenquetefield, { data: tekst })));
    }, 250);
    return () => clearTimeout(klok);
  }, [tekst, opgeslagen, addFields, vraag?.idenquetefield, dispatch]);

  return (
    <TextField
      value={tekst}
      onChange={(e) => setTekst(e.target.value)}
      placeholder={placeholder}
      multiline
      minRows={minRows}
      fullWidth
      inputProps={{ "aria-label": vraag?.name }}
      sx={{
        height: "100%",
        "& .MuiOutlinedInput-root": {
          height: "100%",
          alignItems: "flex-start",
          borderRadius: hoekMaat(14),
          backgroundColor: Css?.QuestionCardBgClr || "#FDFDFD",
          "& fieldset": { borderColor: Css?.QuestionCardBorderClr || "rgba(0,0,0,0.08)" },
          "&.Mui-focused fieldset": { borderColor: "#0B5753" },
        },
      }}
    />
  );
};
